<template>
    <ui-input-base-text
        v-bind:is-invalid="isInvalid"
        v-bind="model"
        v-bind:formatter="formatter"
        v-on:input="inputHandler"
        v-on:focus="focusHandler"
        v-on:blur="blurHandler"
    />
</template>

<script>
export default {
    name: 'ui-input-text',
    props: {
        model: {
            type: Object,
        },
        isInvalid: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [ String, Number ],
        },
    },
    model: {
        prop: 'value',
        event: 'input',
    },
    computed: {
        formatter() {
            if (this.model.maxLength) {
                return (newValue) => newValue.slice(0, this.model.maxLength);
            }
            return null;
        },
    },
    methods: {
        inputHandler(newValue) {
            this.$emit('input', newValue);
        },
        focusHandler(data) {
            this.$emit('focus', data);
        },
        blurHandler(data) {
            this.$emit('blur', data);
        },
    },
};
</script>

<style scoped lang="less">
@import "~theme";

.ui-input-text {
    width: 100%;
}
</style>
